import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.REACT_APP_DISTRIBUTION_API_BASE_URL;

export const socket = io(URL, {
  autoConnect: false,
  transports: ["polling", "websocket"],
  withCredentials: false,
});